import React from 'react';
import { Col, Divider, Row } from 'antd';

import {
  MemberHistoryDetailsModel,
  ProfileCorporatePrimaryContactInfoModel,
} from 'api/adminApiClient';
import HistoryLog from '../../HistoryLog';
import HistoryField from '../../HistoryField';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: MemberHistoryDetailsModel;
  historyId: string;
};

export default function PrimaryContactInformationDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;

  const renderPrimaryContacts = (
    primaryContacts?: ProfileCorporatePrimaryContactInfoModel[],
  ) => {
    const sectionName = 'primary-contact';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Primary contact</div>
          </Col>

          <Col xs={24}>
            {primaryContacts?.length ? (
              primaryContacts.map((primaryContact, index) => (
                <React.Fragment key={`${primaryContact.contactId}-${index}`}>
                  <Row gutter={[10, 10]}>
                    <HistoryField
                      title="First name"
                      value={primaryContact?.firstName}
                      dataId={`${sectionName}-first-name-field`}
                    />
                    <HistoryField
                      title="Last name"
                      value={primaryContact?.lastName}
                      dataId={`${sectionName}-last-name-field`}
                    />
                    <HistoryField
                      title="Email"
                      value={primaryContact?.email}
                      dataId={`${sectionName}-email-field`}
                    />
                    <HistoryField
                      title="Phone number"
                      value={primaryContact?.phoneNumber}
                      dataId={`${sectionName}-phone-number-field`}
                    />
                    <HistoryField
                      title="Title"
                      value={primaryContact?.title}
                      dataId={`${sectionName}-title-field`}
                    />
                  </Row>

                  <Divider />
                </React.Fragment>
              ))
            ) : (
              <div className={styles.noDataMessage}>No data</div>
            )}
          </Col>
        </Row>

        <Divider />
      </>
    );
  };

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderPrimaryContacts(oldData?.corporateInfo?.primaryContacts)}
      newData={renderPrimaryContacts(newData?.corporateInfo?.primaryContacts)}
    />
  );
}
